<custom-navbar barTitle="아이디 / 비밀번호 찾기" [showSetting]="false" [showBack]="false"></custom-navbar>
<div class="find-id-wrap">
  <div class="box">
    <img src="assets/images/idpw_result_02.png">
    <div class="text">{{userName}}님의 아이디(ID)는<p>{{userId}}</p>입니다.</div>
    <button class="login-btn" mat-button (click)="moveLoginPage()">로그인</button>
    <button class="find-pw-btn" mat-button (click)="moveFindPrivacyPage()">비밀번호 찾기</button>
  </div>
</div>
